export default {
  path: '/index',
  name: 'index',
  redirect: {
    name: 'memberCenter'
  },
  component: function component() {
    return import('@/layouts/basic-layout');
  },
  children: [{
    path: 'contractManage',
    name: 'contractManage',
    meta: {
      title: '合同管理',
      menuTab: '',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['contractManage']
    },
    component: function component() {
      return import('@/pages/contractModule/electronicContractMenu/contractManage/contractManage');
    }
  }, // 合同管理-合同模板-合同条款查询
  {
    path: 'contractTermsList',
    name: 'contractTermsList',
    meta: {
      title: '合同条款查询',
      menuTab: '',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['contractTermsList']
    },
    component: function component() {
      return import('@/pages/contractModule/contractTemplateMenu/contractTermsList/contractTermsList');
    }
  }, // 合同管理-合同模板-合同条款详情
  {
    path: 'contractTermsDetail',
    name: 'contractTermsDetail',
    meta: {
      title: '合同条款详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/contractTemplateMenu/contractTermsList/contractTermsDetail');
    }
  }, // 合同管理-合同模板-合同条款维护列表
  {
    path: 'contractTermsMaintainList',
    name: 'contractTermsMaintainList',
    meta: {
      title: '合同条款维护',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['contractTermsMaintainList']
    },
    component: function component() {
      return import('@/pages/contractModule/contractTemplateMenu/contractTermsMaintainList/contractTermsMaintainList');
    }
  }, // 合同管理-合同模板-合同条款新增
  {
    path: 'contractTermsMaintainAdd',
    name: 'contractTermsMaintainAdd',
    meta: {
      title: '合同条款新增',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/contractTemplateMenu/contractTermsMaintainList/contractTermsMaintainAdd');
    }
  }, // 合同管理-合同模板-合同条款修改
  {
    path: 'contractTermsMaintainEdit',
    name: 'contractTermsMaintainEdit',
    meta: {
      title: '合同条款修改',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/contractTemplateMenu/contractTermsMaintainList/contractTermsMaintainEdit');
    }
  }, // 合同管理-合同模板-合同模板查询
  {
    path: 'contractTemplateList',
    name: 'contractTemplateList',
    meta: {
      title: '合同模板查询',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['contractTemplateList']
    },
    component: function component() {
      return import('@/pages/contractModule/contractTemplateMenu/contractTemplateList/contractTemplateList');
    }
  }, // 合同管理-合同模板-合同模板详情
  {
    path: 'contractTemplateDetail',
    name: 'contractTemplateDetail',
    meta: {
      title: '合同模板详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/contractTemplateMenu/contractTemplateList/contractTemplateDetail');
    }
  }, // 合同管理-合同模板-合同模板维护
  {
    path: 'contractTemplateMaintainList',
    name: 'contractTemplateMaintainList',
    meta: {
      title: '合同模板维护',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['contractTemplateMaintainList']
    },
    component: function component() {
      return import('@/pages/contractModule/contractTemplateMenu/contractTemplateMaintainList/contractTemplateMaintainList');
    }
  }, // 合同管理-合同模板-合同模板新增
  {
    path: 'contractTemplateMaintainAdd',
    name: 'contractTemplateMaintainAdd',
    meta: {
      title: '合同模板新增',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/contractTemplateMenu/contractTemplateMaintainList/contractTemplateMaintainAdd');
    }
  }, // 合同管理-合同模板-合同模板修改
  {
    path: 'contractTemplateMaintainEdit',
    name: 'contractTemplateMaintainEdit',
    meta: {
      title: '合同模板修改',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/contractTemplateMenu/contractTemplateMaintainList/contractTemplateMaintainEdit');
    }
  }, // 合同管理-订单合同-订单合同查询
  {
    path: 'orderContractList',
    name: 'orderContractList',
    meta: {
      title: '订单合同维护',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['orderContractList']
    },
    component: function component() {
      return import('@/pages/contractModule/unitContractMenu/orderContractList/orderContractList');
    }
  }, // 合同管理-订单合同-新增订单合同
  {
    path: 'orderContractAdd',
    name: 'orderContractAdd',
    meta: {
      title: '新增订单合同',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/unitContractMenu/orderContractList/orderContractAdd');
    }
  }, // 合同管理-订单合同-订单合同详情
  {
    path: 'orderContractDetail',
    name: 'orderContractDetail',
    meta: {
      title: '订单合同详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/unitContractMenu/orderContractList/orderContractDetail');
    }
  }, // 合同管理-订单合同-修改订单合同
  {
    path: 'orderContractEdit',
    name: 'orderContractEdit',
    meta: {
      title: '修改订单合同',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/unitContractMenu/orderContractList/orderContractEdit');
    }
  }, // 合同管理-订单合同变更-采购订单合同变更
  {
    path: 'orderContractChangeList',
    name: 'orderContractChangeList',
    meta: {
      title: '订单合同变更',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['orderContractChangeList']
    },
    component: function component() {
      return import('@/pages/contractModule/unitContractMenu/orderContractChangeList/orderContractChangeList');
    }
  }, // 合同管理-订单合同变更-采购订单合同变更修改
  {
    path: 'orderContractChangeEdit',
    name: 'orderContractChangeEdit',
    meta: {
      title: '修改订单合同变更申请',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/unitContractMenu/orderContractChangeList/orderContractChangeEdit');
    }
  }, // 合同管理-订单合同变更-采购订单合同变更新增
  {
    path: 'orderContractChangeAdd',
    name: 'orderContractChangeAdd',
    meta: {
      title: '新增订单合同变更',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/unitContractMenu/orderContractChangeList/orderContractChangeAdd');
    }
  }, // 合同管理-订单合同变更-采购订单合同变更新增
  {
    path: 'orderContractChangeDetail',
    name: 'orderContractChangeDetail',
    meta: {
      title: '订单合同变更详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/unitContractMenu/orderContractChangeList/orderContractChangeDetail');
    }
  }, // 合同管理-单位协议合同-单位协议合同维护
  {
    path: 'unitAgrContractList',
    name: 'unitAgrContractList',
    meta: {
      title: '单位协议合同维护',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['unitAgrContractList']
    },
    component: function component() {
      return import('@/pages/contractModule/unitContractMenu/unitAgrContractList/unitAgrContractList');
    }
  }, // 合同管理-单位协议合同-单位协议合同新增
  {
    path: 'unitAgrContractAdd',
    name: 'unitAgrContractAdd',
    meta: {
      title: '单位协议合同新增',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/unitContractMenu/unitAgrContractList/unitAgrContractAdd');
    }
  }, // 合同管理-单位协议合同-单位协议合同详情
  {
    path: 'unitAgrContractDetail',
    name: 'unitAgrContractDetail',
    meta: {
      title: '单位协议合同详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/unitContractMenu/unitAgrContractList/unitAgrContractDetail');
    }
  }, // 合同管理-单位协议合同-单位协议合同修改
  {
    path: 'unitAgrContractEdit',
    name: 'unitAgrContractEdit',
    meta: {
      title: '单位协议合同修改',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/unitContractMenu/unitAgrContractList/unitAgrContractEdit');
    }
  }, // 合同管理-单位协议合同变更-单位协议合同变更
  {
    path: 'unitAgrContractChangeList',
    name: 'unitAgrContractChangeList',
    meta: {
      title: '单位协议合同变更',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['unitAgrContractChangeList']
    },
    component: function component() {
      return import('@/pages/contractModule/unitContractMenu/unitAgrContractChangeList/unitAgrContractChangeList');
    }
  }, // 合同管理-单位协议合同变更-单位协议合同变更修改
  {
    path: 'unitAgrContractChangeEdit',
    name: 'unitAgrContractChangeEdit',
    meta: {
      title: '协议合同变更修改',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/unitContractMenu/unitAgrContractChangeList/unitAgrContractChangeEdit');
    }
  }, // 合同管理-单位协议合同变更-协议合同变更新增
  {
    path: 'unitAgrContractChangeAdd',
    name: 'unitAgrContractChangeAdd',
    meta: {
      title: '协议合同变更新增',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/unitContractMenu/unitAgrContractChangeList/unitAgrContractChangeAdd');
    }
  }, // 合同管理-单位协议合同变更-单位协议合同详情
  {
    path: 'unitAgrContractChangeDetail',
    name: 'unitAgrContractChangeDetail',
    meta: {
      title: '协议合同变更详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/unitContractMenu/unitAgrContractChangeList/unitAgrContractChangeDetail');
    }
  }, // 合同管理-内部单位合同管理-入驻合同维护
  {
    path: 'enterContractList',
    name: 'enterContractList',
    meta: {
      title: '入驻合同维护',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['enterContractList']
    },
    component: function component() {
      return import('@/pages/contractModule/internalUnitContractMenu/enterContractList/enterContractList');
    }
  }, // 合同管理-内部单位合同管理-入驻合同新增
  {
    path: 'enterContractAdd',
    name: 'enterContractAdd',
    meta: {
      title: '入驻合同维护',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/internalUnitContractMenu/enterContractList/enterContractAdd');
    }
  }, // 合同管理-内部单位合同管理-入驻合同详情
  {
    path: 'enterContractDetail',
    name: 'enterContractDetail',
    meta: {
      title: '入驻合同详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/internalUnitContractMenu/enterContractList/enterContractDetail');
    }
  }, // 合同管理-内部单位合同管理-入驻合同修改
  {
    path: 'enterContractEdit',
    name: 'enterContractEdit',
    meta: {
      title: '入驻合同修改',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/internalUnitContractMenu/enterContractList/enterContractEdit');
    }
  }, // 合同管理-内部单位合同管理-入驻合同变更
  {
    path: 'enterContractChangeList',
    name: 'enterContractChangeList',
    meta: {
      title: '入驻合同变更',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['enterContractChangeList']
    },
    component: function component() {
      return import('@/pages/contractModule/internalUnitContractMenu/enterContractChangeList/enterContractChangeList');
    }
  }, // 合同管理-内部单位合同管理-入驻合同变更修改
  {
    path: 'enterContractChangeEdit',
    name: 'enterContractChangeEdit',
    meta: {
      title: '入驻合同变更修改',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/internalUnitContractMenu/enterContractChangeList/enterContractChangeEdit');
    }
  }, // 合同管理-内部单位合同管理-入驻合同变更申请
  {
    path: 'enterContractChangeAdd',
    name: 'enterContractChangeAdd',
    meta: {
      title: '入驻合同变更申请',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/internalUnitContractMenu/enterContractChangeList/enterContractChangeAdd');
    }
  }, // 合同管理-合同签章管理-证书实名认证（法大大）
  {
    path: 'realNameCertificationFdd',
    name: 'realNameCertificationFdd',
    meta: {
      title: '证书实名认证（法大大）',
      cache: true
    },
    component: function component() {
      return import('@/pages/contractModule/contractSignMenu/realNameCertificationFdd');
    }
  }, // 合同管理-合同签章管理-个人证书实名认证（e签宝）
  {
    path: 'realNameCertificationEqb',
    name: 'realNameCertificationEqb',
    meta: {
      title: '个人证书实名认证（e签宝）',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['realNameCertificationEqb']
    },
    component: function component() {
      return import('@/pages/contractModule/contractSignMenu/realNameCertificationEqb');
    }
  }, // 合同管理-合同签章管理-企业证书实名认证（e签宝）
  {
    path: 'realNameCertificationQYEqb',
    name: 'realNameCertificationQYEqb',
    meta: {
      title: '企业证书实名认证（e签宝）',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['realNameCertificationQYEqb']
    },
    component: function component() {
      return import('@/pages/contractModule/contractSignMenu/realNameCertificationQYEqb');
    }
  }, // 合同管理-内部单位合同管理-入驻合同变更详情
  {
    path: 'enterContractChangeDetail',
    name: 'enterContractChangeDetail',
    meta: {
      title: '入驻合同变更详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/internalUnitContractMenu/enterContractChangeList/enterContractChangeDetail');
    }
  }, // 合同管理-内部单位合同管理-订单合同签订
  {
    path: 'uOrderContractList',
    name: 'uOrderContractList',
    meta: {
      title: '订单合同签订',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['uOrderContractList']
    },
    component: function component() {
      return import('@/pages/contractModule/internalUnitContractMenu/uOrderContractList/uOrderContractList');
    }
  }, // 合同管理-内部单位合同管理-平台协议合同维护
  {
    path: 'platformAgrContractList',
    name: 'platformAgrContractList',
    meta: {
      title: '平台协议合同维护',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['platformAgrContractList']
    },
    component: function component() {
      return import('@/pages/contractModule/internalUnitContractMenu/platformAgrContractList/platformAgrContractList');
    }
  }, // 合同管理-内部单位合同管理-平台协议合同新增
  {
    path: 'platformAgrContractAdd',
    name: 'platformAgrContractAdd',
    meta: {
      title: '平台协议合同新增',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/internalUnitContractMenu/platformAgrContractList/platformAgrContractAdd');
    }
  }, // 合同管理-内部单位合同管理-平台协议合同编辑
  {
    path: 'platformAgrContractEdit',
    name: 'platformAgrContractEdit',
    meta: {
      title: '平台协议合同新增',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/internalUnitContractMenu/platformAgrContractList/platformAgrContractEdit');
    }
  }, // 合同管理-内部单位合同管理-平台协议合同详情
  {
    path: 'platformAgrContractDetail',
    name: 'platformAgrContractDetail',
    meta: {
      title: '平台协议合同详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/internalUnitContractMenu/platformAgrContractList/platformAgrContractDetail');
    }
  }, // 合同管理-内部单位合同管理-协议合同变更
  {
    path: 'platformAgrContractChangeList',
    name: 'platformAgrContractChangeList',
    meta: {
      title: '平台协议合同变更',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['platformAgrContractChangeList']
    },
    component: function component() {
      return import('@/pages/contractModule/internalUnitContractMenu/platformAgrContractChangeList/platformAgrContractChangeList');
    }
  }, // 合同管理-内部单位合同管理-协议合同变更新增
  {
    path: 'platformAgrContractChangeAdd',
    name: 'platformAgrContractChangeAdd',
    meta: {
      title: '协议合同变更新增',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/internalUnitContractMenu/platformAgrContractChangeList/platformAgrContractChangeAdd');
    }
  }, // 合同管理-内部单位合同管理-协议合同变更修改
  {
    path: 'platformAgrContractChangeEdit',
    name: 'platformAgrContractChangeEdit',
    meta: {
      title: '协议合同变更修改',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/internalUnitContractMenu/platformAgrContractChangeList/platformAgrContractChangeEdit');
    }
  }, // 合同管理-内部单位合同管理-协议合同变更详情
  {
    path: 'platformAgrContractChangeDetail',
    name: 'platformAgrContractChangeDetail',
    meta: {
      title: '协议合同变更详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/internalUnitContractMenu/platformAgrContractChangeList/platformAgrContractChangeDetail');
    }
  }, // 合同管理-合同审批管理-平台协议合同审批
  {
    path: 'platformAgreementApprovalList',
    name: 'platformAgreementApprovalList',
    meta: {
      title: '平台协议合同审批',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['platformAgreementApprovalList']
    },
    component: function component() {
      return import('@/pages/contractModule/contractApprovalMenu/platformAgreementApprovalList/platformAgreementApprovalList');
    }
  }, // 合同管理-合同审批管理-平台协议合同审批
  {
    path: 'platformAgreementApprovalDetail',
    name: 'platformAgreementApprovalDetail',
    meta: {
      title: '平台协议合同审批',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/contractApprovalMenu/platformAgreementApprovalList/platformAgreementApprovalDetail');
    }
  }, // 合同管理-合同审批管理-平台协议合同变更审批
  {
    path: 'platformAgreementChangeApprovalList',
    name: 'platformAgreementChangeApprovalList',
    meta: {
      title: '平台协议合同变更审批',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['platformAgreementChangeApprovalList']
    },
    component: function component() {
      return import('@/pages/contractModule/contractApprovalMenu/platformAgreementChangeApprovalList/platformAgreementChangeApprovalList');
    }
  }, // 合同管理-合同审批管理-平台协议合同变更审批
  {
    path: 'platformAgreementChangeApprovalDetail',
    name: 'platformAgreementChangeApprovalDetail',
    meta: {
      title: '平台协议合同变更审批',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/contractApprovalMenu/platformAgreementChangeApprovalList/platformAgreementChangeApprovalDetail');
    }
  }, // 合同管理-合同审批管理-订单协议合同审批
  {
    path: 'orderContractApprovalList',
    name: 'orderContractApprovalList',
    meta: {
      title: '订单合同审批',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['orderContractApprovalList']
    },
    component: function component() {
      return import('@/pages/contractModule/contractApprovalMenu/orderContractApprovalList/orderContractApprovalList');
    }
  }, // 合同管理-合同审批管理-订单协议合同变更审批
  {
    path: 'orderContractChangeApprovalList',
    name: 'orderContractChangeApprovalList',
    meta: {
      title: '订单合同变更审批',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['orderContractChangeApprovalList']
    },
    component: function component() {
      return import('@/pages/contractModule/contractApprovalMenu/orderContractChangeApprovalList/orderContractChangeApprovalList');
    }
  }, // 合同管理-合同审批管理-入驻合同审批
  {
    path: 'contractApproveList',
    name: 'contractApproveList',
    meta: {
      title: '入驻合同审批',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['contractApproveList']
    },
    component: function component() {
      return import('@/pages/contractModule/contractApprovalMenu/contractApproveList/contractApproveList');
    }
  }, // 合同管理-合同审批管理-入驻合同审批通过驳回以及详情
  {
    path: 'contractApproveDetail',
    name: 'contractApproveDetail',
    meta: {
      title: '入驻合同审批详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/contractApprovalMenu/contractApproveList/contractApproveDetail');
    }
  }, // 合同管理-合同审批管理-入驻合同审批通过驳回以及详情
  {
    path: 'contractApproveChDetail',
    name: 'contractApproveChDetail',
    meta: {
      title: '入驻合同变更审批详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/contractApprovalMenu/contractApproveChList/contractApproveChDetail');
    }
  }, // 合同管理-合同变更审批管理-订单合同变更审批通过驳回以及详情
  {
    path: 'orderContractChangeApprovalDetail',
    name: 'orderContractChangeApprovalDetail',
    meta: {
      title: '订单合同变更审批详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/contractApprovalMenu/orderContractChangeApprovalList/orderContractChangeApprovalDetail');
    }
  }, // 合同管理-合同审批管理-协议合同签订
  {
    path: 'argContractSiList',
    name: 'argContractSiList',
    meta: {
      title: '协议合同签订',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['argContractSiList']
    },
    component: function component() {
      return import('@/pages/contractModule/supplierContractMenu/argContractSiList/argContractSiList');
    }
  }, // 合同管理-合同审批管理-协议合同签订
  {
    path: 'argContractSiDetail',
    name: 'argContractSiDetail',
    meta: {
      title: '协议合同签订详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/supplierContractMenu/argContractSiList/argContractSiDetail');
    }
  }, // 合同管理-合同审批管理-订单合同签订
  {
    path: 'orContractSiList',
    name: 'orContractSiList',
    meta: {
      title: '订单合同签订',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['orContractSiList']
    },
    component: function component() {
      return import('@/pages/contractModule/supplierContractMenu/orContractSiList/orContractSiList');
    }
  }, // 合同管理-合同审批管理-订单合同签订
  {
    path: 'orContractSiDetail',
    name: 'orContractSiDetail',
    meta: {
      title: '订单合同签订详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/supplierContractMenu/orContractSiList/orContractSiDetail');
    }
  }, // 合同管理-合同审批管理-入驻合同签订
  {
    path: 'enterContractSiList',
    name: 'enterContractSiList',
    meta: {
      title: '入驻合同签订',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['enterContractSiList']
    },
    component: function component() {
      return import('@/pages/contractModule/supplierContractMenu/enterContractSiList/enterContractSiList');
    }
  }, // 合同管理-合同审批管理-入驻合同签订详情
  {
    path: 'enterContractSiDetail',
    name: 'enterContractSiDetail',
    meta: {
      title: '入驻合同签订详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/supplierContractMenu/enterContractSiList/enterContractSiDetail');
    }
  }, // 合同管理-合同审批管理-单位合同审批
  {
    path: 'contractApproveChList',
    name: 'contractApproveChList',
    meta: {
      title: '入驻合同变更审批',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['contractApproveChList']
    },
    component: function component() {
      return import('@/pages/contractModule/contractApprovalMenu/contractApproveChList/contractApproveChList.vue');
    }
  }, // 合同管理-合同审批管理-单位合同审批
  {
    path: 'unitContractApproveList',
    name: 'unitContractApproveList',
    meta: {
      title: '单位协议合同审批',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['unitContractApproveList']
    },
    component: function component() {
      return import('@/pages/contractModule/contractApprovalMenu/unitContractApproveList/unitContractApproveList');
    }
  }, // 合同管理-合同审批管理-协议合同审批通过驳回以及详情
  {
    path: 'unitContractApproveDetail',
    name: 'unitContractApproveDetail',
    meta: {
      title: '协议合同审批详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/contractApprovalMenu/unitContractApproveList/unitContractApproveDetail');
    }
  }, // 合同管理-合同审批管理-订单合同审批
  {
    path: 'orderContractApprovalDetail',
    name: 'orderContractApprovalDetail',
    meta: {
      title: '订单合同审批详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/contractApprovalMenu/orderContractApprovalList/orderContractApprovalDetail');
    }
  }, // 合同管理-合同审批管理-单位合同变更审批
  {
    path: 'unitContractApproveChList',
    name: 'unitContractApproveChList',
    meta: {
      title: '单位协议合同变更审批',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['unitContractApproveChList']
    },
    component: function component() {
      return import('@/pages/contractModule/contractApprovalMenu/unitContractApproveChList/unitContractApproveChList');
    }
  }, // 合同管理-合同审批管理-单位协议合同变更审批详情
  {
    path: 'unitContractApproveChDetail',
    name: 'unitContractApproveChDetail',
    meta: {
      title: '单位协议合同变更审批详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/contractModule/contractApprovalMenu/unitContractApproveChList/unitContractApproveChDetail');
    }
  }]
};